import { render, staticRenderFns } from "./Resource.vue?vue&type=template&id=7a73262a&scoped=true&"
import script from "./Resource.vue?vue&type=script&lang=ts&"
export * from "./Resource.vue?vue&type=script&lang=ts&"
import style0 from "./Resource.vue?vue&type=style&index=0&id=7a73262a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a73262a",
  null
  
)

export default component.exports